import Handlebars from '../../shared/handlebar-helpers';
import Notification from '../../shared/notification';

import activityHndb from '../templates/activity.handlebars';
import activityListContentHndb from '../templates/activity-list-content.handlebars';
import { View } from './view';

export default class Activity extends View {
    constructor(view, data, app, { preSubmit = null, postSubmit = null } = {}) {
        super(view);
        this.data = data;
        this.app = app;
        this.view = view;
        this.activityEl = document.createElement('div');
        this.preSubmit = preSubmit;
        this.postSubmit = postSubmit;
    }

    #scrollBottom = () => {
        setTimeout(() => {
            const list = this.activityEl.querySelector('#activity-list');
            if (list) list.scrollTop = list.scrollHeight;

            const view = this.activityEl.querySelector('#activity-view');
            view.scrollTop = view.scrollHeight;
        }, 10);
    }

    #closeMoreActivity = () => {
        const moreActivityEl = this.activityEl.querySelector('#more-activity');

        moreActivityEl.style.top = '0%';
        moreActivityEl.style.opacity = '0';

        moreActivityEl.removeAttribute('style');
        moreActivityEl.setAttribute('hidden', '');
    }

    #hideFormInputs = () => {
        const hiddenInputsEl = this.activityEl.querySelector('#hidden-inputs');
        const hiddenActivityInputsEl = this.activityEl.querySelector('#activity-inputs');
        const formContainerEl = this.activityEl.querySelector('#form-fieldset');

        hiddenActivityInputsEl.setAttribute('hidden', '');
        hiddenInputsEl.setAttribute('hidden', '');
        formContainerEl.removeAttribute('expanded');
    }

    #showFormInputs = () => {
        const hiddenInputsEl = this.activityEl.querySelector('#hidden-inputs');
        const hiddenActivityInputsEl = this.activityEl.querySelector('#activity-inputs');
        const formContainerEl = this.activityEl.querySelector('#form-fieldset');

        hiddenInputsEl.removeAttribute('hidden');
        hiddenActivityInputsEl.removeAttribute('hidden');
        formContainerEl.setAttribute('expanded', '');
    }

    #resetInputs = () => {
        const messageFormEl = this.activityEl.querySelector('#form-activity-message');
        const activitiesInput = this.activityEl.querySelector('#activity-inputs');

        this.#scrollBottom();
        this.#hideFormInputs();

        messageFormEl.ariaReadOnly = false;
        messageFormEl.removeAttribute('readOnly');
        messageFormEl.value = '';
        messageFormEl.setAttribute('placeholder', Handlebars.translation.activity.select_type_first);
        
        activitiesInput.querySelector('input').checked = true;
    }

    #listeners() {

        const impactSelect = this.activityEl.querySelector('#filter-activity-impact');
        if (impactSelect) {
            impactSelect.addEventListener('change', (e) => {
                const selectedImpact = e.target.value;
                this.data.selected_impact = selectedImpact;
                this.#updateActivityListContent();
            });
        }

        this.activityEl.querySelector("#activity-form").addEventListener('click', (e) => {
            this.#showFormInputs(e);
            this.#scrollBottom();
        });

        // Close the more activity and hidden inputs when clicking outside of the form
        this.activityEl.addEventListener('click', (e) => {

            // Close when clicking outside activity inputs
            if (!this.activityEl.querySelector("#activity-inputs").contains(e.target)) {
                this.#closeMoreActivity();
            }
            
            // Close when clicking outside the form
            if (!this.activityEl.querySelector("#activity-form").contains(e.target)) {
                this.#hideFormInputs();
            }

        });

        // Show more activities when clicking on the "toggle" button
        this.activityEl.querySelector('#more-activity-toggle').addEventListener('click', (e) => {
            const moreActivityEl = this.activityEl.querySelector('#more-activity');
            moreActivityEl.removeAttribute('hidden');
        });
        
        // Show the appropiate hidden activity on the toggle when selecting an activity
        this.activityEl.querySelector('#activity-inputs').addEventListener('change', (e) => {
            const moreActivityEl = this.activityEl.querySelector('#more-activity');
            const moreActivityTxt = this.activityEl.querySelector('#more-activity-text');
            const moreActivityInp = this.activityEl.querySelector('#more-activity-toggle');
            const submitInp = this.activityEl.querySelector('#activity-submit');

            const messageFormEl = this.activityEl.querySelector('#form-activity-message');

            if (moreActivityEl.contains(e.target)) {
                moreActivityTxt.textContent = `${e.target.nextElementSibling.textContent}...`;
                moreActivityInp.checked = true;
            } else {
                moreActivityTxt.textContent = `...${Handlebars.translation.general.more}`;
                moreActivityInp.checked = false;
            }

            if (e.target !== moreActivityInp) {
                messageFormEl.removeAttribute('placeholder');
                
                if (e.target.dataset.hasOwnProperty('disable')) {
                    messageFormEl.ariaReadOnly = true;
                    messageFormEl.setAttribute('readOnly', '');
                } else {  
                    messageFormEl.ariaReadOnly = false;
                    messageFormEl.removeAttribute('readOnly');
                }

                if (e.target.dataset.hasOwnProperty('defaultMessage')) {
                    messageFormEl.value = e.target.dataset.defaultMessage.replaceAll('\\n', '\n');
                }

                submitInp.removeAttribute('disabled');
            }


            if (moreActivityEl.hasAttribute('hidden')) return;

            // Ignore clicks on the toggle button
            if (e.target.id === 'more-activity-toggle') return;

            this.#closeMoreActivity();
        });


        this.activityEl.addEventListener('submit', async (e) => {
            e.preventDefault();

            const notification = new Notification({
                type: 'loading',
            });
            notification.open();

            const formData = new FormData(e.target);
            const body = {};

            for (const [key, value] of formData.entries()) {
                body[key] = value; // field now 'message'
            }

            if (this.preSubmit) {
                this.preSubmit(body);
            }

            const {data, status, message} = await this.app.service.saveActivity(
                this.data.quote_id,
                body
            );

            if (this.postSubmit) {
                this.postSubmit({data, status, message});
            }

            if (status === 0) {
                if (this.data.isFast) {
                    notification.close(); 
                    return this.view.close();
                }

                const { data: activities, status, message } = await this.app.service.getActivities(this.data.quote_id);
                this.#addActivity(activities);
                notification.close();                
            } else {
                notification.reload({
                    type: 'error',
                    title: message
                });
            }
        });
    }

    #init() {
        this.#scrollBottom();
        const d = new Date();
        const dateTimeLocalValue = new Date(
            d.getTime() - d.getTimezoneOffset() * 60000
        )
            .toISOString()
            .slice(0, -8);


        this.activityEl.querySelector('#form-activity-date').value =
            dateTimeLocalValue;

        if (this.data.win) {
            this.activityEl.querySelector('#form-activity-win').value =
                this.data.win;
        }

        if (this.data.isFast) {
            const messageFormEl = this.activityEl.querySelector('#form-activity-message');
            if (messageFormEl) {
                messageFormEl.click();
            }
        }
    }

    #addActivity(activities) {
        this.data.activities = activities.activities;
        this.#updateActivityListContent();
        this.#resetInputs();
    }

    #updateActivityListContent() {
        const activityListContentEl = this.activityEl.querySelector('#activity-list-content');
        const contentHtml = activityListContentHndb(this.data);
        activityListContentEl.innerHTML = contentHtml;
    }

    open() {
        this.activityEl = this.view.update(activityHndb(this.data)).modalContainer;
        this.view.open();
        this.#listeners();
        this.#init();
    }
}
